import { Component, OnInit } from '@angular/core';
import { ManagementComponent } from '../management.component';
import { B2BService } from 'src/app/b2-b.service';
import { SharedService } from 'src/app/shared.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-partners-transit-items',
  templateUrl: './partners-transit-items.component.html',
  styleUrls: ['./partners-transit-items.component.css']
})
export class PartnersTransitItemsComponent implements OnInit {

  parent: ManagementComponent;
  TransitItems: any[] = [];
  Partners: any[] = [];

  partnerSearchTerms: { [key: number]: Subject<string> } = {};
  partnerSearchResults: { [key: number]: any[] } = {};
  partnerSearchInputs: { [key: number]: string } = {};
  loadingPartners: { [key: number]: boolean } = {};
  selectedPartners: { [key: number]: any } = {};

  // Global filter and search
  FilteredPartner: any = null;
  globalPartnerSearchTerm: string = '';
  globalPartnerSearchResults: any[] = [];
  globalPartnerSearchSubject: Subject<string> = new Subject<string>();

  // Pagination
  CurrentPage: number = 1;
  PageSize: number = 10;
  TotalCount: number = 0;
  TotalPages: number = 0;
  Math = Math;

  // Delete confirmation
  ShowDeleteConfirmation: boolean = false;
  ItemToDelete: any = null;
  ItemToDeleteIndex: number = -1;
  deletingItems: { [key: number]: boolean } = {};

  constructor(
    parent: ManagementComponent,
    private B2BService: B2BService,
    private service: SharedService
  ) {
    this.parent = parent;
  }

  ngOnInit(): void {
    this.setupGlobalPartnerSearch();
    this.GetOrderConfirmationsTransitItems();
  }

  GetOrderConfirmationsTransitItems() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.FilteredPartner?.ID || "",
      Filter: {
        Pager: {
          PageIndex: this.CurrentPage,
          PageSize: this.PageSize,
          TotalCount: 0
        }
      }
    };

    this.parent.loading = true;

    this.B2BService.GetOrderConfirmationsTransitItemsWithPartner(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        this.TransitItems = response["TransitItems"];

        // Update pagination info
        if (response["Filter"] && response["Filter"]["Pager"]) {
          this.TotalCount = response["Filter"]["Pager"]["TotalCount"];
          this.TotalPages = response["Filter"]["Pager"]["Pages"];
        }

        // Initialize partner search subjects for each item
        this.TransitItems.forEach((item, index) => {
          if (!this.partnerSearchTerms[index]) {
            this.partnerSearchTerms[index] = new Subject<string>();
            this.setupPartnerSearch(index);
          }

          // Set initial selected partner if exists
          if (item.Partner) {
            this.selectedPartners[index] = item.Partner;
          }
        });
      }

      this.parent.loading = false;
    });
  }

  setupPartnerSearch(itemIndex: number) {
    this.partnerSearchTerms[itemIndex]
      .pipe(
        debounceTime(250),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        if (searchTerm && searchTerm.length >= 2) {
          this.SearchPartnersForItem(itemIndex, searchTerm);
        } else {
          this.partnerSearchResults[itemIndex] = [];
        }
      });
  }

  onPartnerSearchChange(itemIndex: number, searchTerm: string) {
    this.partnerSearchInputs[itemIndex] = searchTerm;
    this.partnerSearchTerms[itemIndex].next(searchTerm);
  }

  SearchPartnersForItem(itemIndex: number, searchTerm: string) {
    var request = {
      SearchTerm: searchTerm,
      PageIndex: 1,
      PageSize: 20,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: this.parent.Company?.ID,
      CheckAdmin: false,
      SearchEUVIES: false
    };

    this.loadingPartners[itemIndex] = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        this.partnerSearchResults[itemIndex] = response["Partners"];
      }

      this.loadingPartners[itemIndex] = false;
    });
  }

  selectPartner(itemIndex: number, partner: any) {
    console.log('selectPartner called', { itemIndex, partner });
    this.selectedPartners[itemIndex] = partner;
    this.partnerSearchResults[itemIndex] = [];
    this.partnerSearchInputs[itemIndex] = ''; // Clear search input

    // Automatically update to database
    const item = this.TransitItems[itemIndex];
    console.log('Transit item:', item);
    this.UpdateTransitItemPartner(item, itemIndex);
  }

  UpdateTransitItemPartner(item: any, itemIndex: number) {
    console.log('UpdateTransitItemPartner called', { item, itemIndex });
    const selectedPartner = this.selectedPartners[itemIndex];
    console.log('Selected partner:', selectedPartner);

    if (!selectedPartner) {
      console.log('No selected partner, returning');
      this.parent.openSnackBar("Please select a partner first", "OK", "alert-info-snackbar");
      return;
    }

    // Create transit item with only the necessary fields
    const updatedItem = {
      CartItemID: item.CartItemID,
      DocumentID: item.DocumentID,
      TransactionDirection: item.TransactionDirection,
      OrderRefferenceNumber: item.OrderRefferenceNumber,
      DebatorPO: item.DebatorPO,
      Brand: item.Brand,
      ProductName: item.ProductName,
      ProductPartNumber: item.ProductPartNumber,
      Quantity: item.Quantity,
      ShippingCompany: item.ShippingCompany,
      ShippingServiceType: item.ShippingServiceType,
      EstiMatedArrivalDate: item.EstiMatedArrivalDate,
      PartnerID: selectedPartner.ID
    };

    console.log('Updated item to send:', updatedItem);

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      TransitItem: updatedItem
    };

    console.log('Request to send:', request);

    this.parent.loading = true;

    this.B2BService.AddUpdateOrderConfirmationTransitItem(request).subscribe(
      response => {
        console.log('Response received:', response);
        if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if (response["Status"] == 1) {
          this.parent.openSnackBar("Partner updated successfully", "OK", "light-info-snackbar");
          // Update the item in the list
          item.Partner = selectedPartner;
          item.PartnerID = selectedPartner.ID;
          this.selectedPartners[itemIndex] = selectedPartner;
        }

        this.parent.loading = false;
      },
      error => {
        console.error('Error occurred:', error);
        this.parent.openSnackBar("Error updating partner: " + error.message, "OK", "alert-info-snackbar");
        this.parent.loading = false;
      }
    );
  }

  clearPartnerSelection(itemIndex: number, item: any) {
    // Clear partner in UI only (no backend call)
    if (item) {
      item.Partner = null;
      item.PartnerID = null;
    }
    this.selectedPartners[itemIndex] = null;
    this.partnerSearchResults[itemIndex] = [];
    this.partnerSearchInputs[itemIndex] = '';
  }

  ClearPartner(item: any, itemIndex: number) {
    // Update the transit item to remove the partner
    const updatedItem = {
      ...item,
      PartnerID: null,
      Partner: null
    };

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      TransitItem: updatedItem
    };

    this.parent.loading = true;

    this.B2BService.AddUpdateOrderConfirmationTransitItem(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        this.parent.openSnackBar("Partner removed successfully", "OK", "light-info-snackbar");
        // Update the item in the list
        item.Partner = null;
        item.PartnerID = null;
        this.selectedPartners[itemIndex] = null;
        this.partnerSearchResults[itemIndex] = [];
      }

      this.parent.loading = false;
    });
  }

  // Global Partner Search and Filter
  setupGlobalPartnerSearch() {
    this.globalPartnerSearchSubject
      .pipe(
        debounceTime(250),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        if (searchTerm && searchTerm.length >= 2) {
          this.SearchGlobalPartners(searchTerm);
        } else {
          this.globalPartnerSearchResults = [];
        }
      });
  }

  onGlobalPartnerSearch(searchTerm: string) {
    this.globalPartnerSearchSubject.next(searchTerm);
  }

  SearchGlobalPartners(searchTerm: string) {
    var request = {
      SearchTerm: searchTerm,
      PageIndex: 1,
      PageSize: 10,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: this.parent.Company?.ID,
      CheckAdmin: false,
      SearchEUVIES: false
    };

    this.service.GetPartnersFiltered(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.globalPartnerSearchResults = response["Partners"];
      }
    });
  }

  ApplyPartnerFilter(partner: any) {
    this.FilteredPartner = partner;
    this.globalPartnerSearchResults = [];
    this.globalPartnerSearchTerm = '';
    this.CurrentPage = 1;
    this.GetOrderConfirmationsTransitItems();
  }

  ClearGlobalFilter() {
    this.FilteredPartner = null;
    this.globalPartnerSearchTerm = '';
    this.globalPartnerSearchResults = [];
    this.CurrentPage = 1;
    this.GetOrderConfirmationsTransitItems();
  }

  // Pagination
  GoToPage(page: number) {
    if (page < 1 || page > this.TotalPages) return;
    this.CurrentPage = page;
    this.GetOrderConfirmationsTransitItems();
  }

  OnPageSizeChange() {
    this.CurrentPage = 1;
    this.GetOrderConfirmationsTransitItems();
  }

  GetPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;

    if (this.TotalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.TotalPages; i++) {
        pages.push(i);
      }
    } else {
      const startPage = Math.max(1, this.CurrentPage - 2);
      const endPage = Math.min(this.TotalPages, startPage + maxPagesToShow - 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

  // Delete functionality
  OpenDeleteConfirmation(item: any, index: number) {
    this.ItemToDelete = item;
    this.ItemToDeleteIndex = index;
    this.ShowDeleteConfirmation = true;
  }

  CloseDeleteConfirmation() {
    this.ShowDeleteConfirmation = false;
    this.ItemToDelete = null;
    this.ItemToDeleteIndex = -1;
  }

  ConfirmDelete() {
    if (!this.ItemToDelete || this.ItemToDeleteIndex < 0) {
      return;
    }

    const cartItemID = this.ItemToDelete.CartItemID;
    const itemIndex = this.ItemToDeleteIndex;

    // Close dialog
    this.CloseDeleteConfirmation();

    // Set loading state for this specific item
    this.deletingItems[itemIndex] = true;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItemID: cartItemID
    };

    this.B2BService.DeleteOrderConfirmationTransitItem(request).subscribe(
      response => {
        if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if (response["Status"] == 1) {
          this.parent.openSnackBar("Transit item deleted successfully", "OK", "light-info-snackbar");

          // Remove item from the list
          this.TransitItems.splice(itemIndex, 1);

          // Update total count
          this.TotalCount--;

          // Recalculate total pages
          this.TotalPages = Math.ceil(this.TotalCount / this.PageSize);

          // If current page is now empty and not the first page, go to previous page
          if (this.TransitItems.length === 0 && this.CurrentPage > 1) {
            this.GoToPage(this.CurrentPage - 1);
          } else if (this.TransitItems.length === 0 && this.CurrentPage === 1) {
            // If we're on page 1 and it's empty, reload to show empty state
            this.GetOrderConfirmationsTransitItems();
          }
        }

        // Clear loading state
        this.deletingItems[itemIndex] = false;
      },
      error => {
        console.error('Error deleting transit item:', error);
        this.parent.openSnackBar("Error deleting transit item: " + error.message, "OK", "alert-info-snackbar");
        this.deletingItems[itemIndex] = false;
      }
    );
  }

}

